import { Component } from "react";

export class AdminErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Admin crashed", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="admin-error-boundary" className="min-h-screen grid place-items-center bg-[#EDECE3] p-6">
        <div className="max-w-lg rounded-3xl border border-destructive/30 bg-white p-8">
          <h1 className="font-serif text-3xl">Something went wrong in the admin panel</h1>
          <p className="mt-2 text-sm text-muted-foreground">The page hit an unexpected error while rendering. Reloading usually fixes it; if it keeps happening, share the message below.</p>
          <pre data-testid="admin-error-message" className="mt-4 whitespace-pre-wrap text-xs bg-muted/50 rounded-xl p-3 text-destructive">{String(this.state.error?.message || this.state.error)}</pre>
          <button data-testid="admin-error-reload" onClick={() => window.location.reload()} className="mt-5 rounded-full bg-primary text-primary-foreground px-6 py-2.5 text-sm">Reload admin</button>
        </div>
      </div>
    );
  }
}
